import { render, staticRenderFns } from "./ToggleColumnsButton.vue?vue&type=template&id=96281a60&scoped=true"
import script from "./ToggleColumnsButton.vue?vue&type=script&lang=js"
export * from "./ToggleColumnsButton.vue?vue&type=script&lang=js"
import style0 from "./ToggleColumnsButton.vue?vue&type=style&index=0&id=96281a60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96281a60",
  null
  
)

export default component.exports